
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ApiGateway, PageOptions } from 'cw-backend';
import { CwUtils } from 'cw-utils';
import { BehaviorSubject, Observable } from 'rxjs';
import { AttendanceRegime } from '../../../models/tables/tiss/attendance-regime';

@Injectable()
export class AttendanceRegimeListProvider implements Resolve<any> {
    attendanceRegime: AttendanceRegime[];
    attendanceRegimeEdit: AttendanceRegime;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        this.currentPage = this.state?.currentPage;
        this.attendanceRegimeEdit = this.state?.currentAttendanceRegime;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
        }
        else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = 'code';
        }
        return new Promise<void>((resolve, reject) => {
            Promise.all([
                this.getPage(this.pageOptions)
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    get(id: number): Observable<AttendanceRegime> {
        if (!id) {
            return null;
        }
        return this.gw.get('attendanceRegime/:id', { id: id });
    }

    get currentAttendanceRegime(): AttendanceRegime {
        return this.attendanceRegimeEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('attendanceRegime/simpleList/').subscribe((res: HttpResponse<any>) => {
                this.attendanceRegime = res.body;
                resolve(res);
            }, reject);
        });

    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('attendanceRegime/search/simple', pageOptions).subscribe((res: HttpResponse<any>) => {
                if (!CwUtils.compare(this.attendanceRegime, res.body.content) && res.body.content.length > 0) {
                    this.attendanceRegime = res.body.content;
                    this.onDataChanged.next(this.attendanceRegime);
                }
                else {
                    this.attendanceRegime = res.body.content;
                };
                resolve(res);
            }, reject);
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}

